import React, { Component } from 'react'
import { stack as Menu } from 'react-burger-menu'
import Link from 'gatsby-link'

import { social } from '../../../data/SiteConfig'
import styles from './AsideMenu.module.scss'

class AsideMenu extends Component {
	render () {
		const { menuItems } = this.props
		return (
			<Menu {...this.props}
			      overlayClassName={styles.overlay}
			      menuClassName={styles.menu}
			      burgerButtonClassName={styles.burgerButton}
			      crossClassName={styles.cross}
			      crossButtonClassName={styles.crossButton}>
			      {
		            menuItems.map(({node:{frontmatter:{part,title,slug}}}, index) => (
		              <Link key={index} to={`/${slug}`} className={styles.menuItemLink} onClick={this.props.hideMenu}>
		                <span className={styles.menuItemTextA}>{part}</span>
		                <span className={styles.menuItemTextB}>{title}</span>
		              </Link>
		            ))
		          }
		          <div className={styles.socialLinks}>
		          	{
		          		social.map(({name, icon, link}, index) => (
		          			<a key={index} href={link} title={name} target="_blank">
		          				<img src={icon} alt={name} title={name} />
		          			</a>
		          		))
		          	}
		          </div>
			</Menu>
		)
	}
}
export default AsideMenu


// WEBPACK FOOTER //
// ./src/components/AsideMenu/AsideMenu.js